import {useParams} from 'react-router-dom';

import {TProjectGroup} from 'Pages/project/project_types';

import useProjectGroup from '../queries/useProjectGroup';

// Use this hook only when you are sure project is loaded
// (basically above ProjectGroupLoader).
const useCurrentProjectGroup = (): TProjectGroup | null => {
  const {projectHash = null} = useParams();
  return useProjectGroup(projectHash).data || null;
};

export default useCurrentProjectGroup;
